export class Protocolo {
  private id_orden_trabajo: number;
  private pedido: string;
  private fecha_pedido: string;
  private entrega_final: string;
  private rotulo: string;
  private visto: boolean;
  private impreso: boolean;
  private estado_resultados: string;
  private estado_validacion: string;
  private tiene_resultados_marcados_para_antecedentes: boolean;
  private letra_origen: string;
  private numero_pedido: string;
  private impreso_fecha: string;
  private visto_fecha: string;
  private es_derivacion: boolean;

  constructor(
    id_orden_trabajo: number,
    pedido: string,
    fecha_pedido: string,
    entrega_final: string,
    rotulo: string,
    visto: boolean,
    impreso: boolean,
    estado_resultados: string,
    estado_validacion: string,
    tiene_resultados_marcados_para_antecedentes: boolean,
    letra_origen: string,
    numero_pedido: string,
    impreso_fecha: string,
    visto_fecha: string,
    es_derivacion: boolean
  ) {
    this.id_orden_trabajo = id_orden_trabajo;
    this.pedido = pedido;
    this.fecha_pedido = fecha_pedido;
    this.entrega_final = entrega_final;
    this.rotulo = rotulo;
    this.visto = visto;
    this.impreso = impreso;
    this.estado_resultados = estado_resultados;
    this.estado_validacion = estado_validacion;
    this.tiene_resultados_marcados_para_antecedentes =
      tiene_resultados_marcados_para_antecedentes;
    this.letra_origen = letra_origen;
    this.numero_pedido = numero_pedido;
    this.impreso_fecha = impreso_fecha;
    this.visto_fecha = visto_fecha;
    this.es_derivacion = es_derivacion;
  }

  // Getters and Setters

  public getIdOrdenTrabajo(): number {
    return this.id_orden_trabajo;
  }

  public setIdOrdenTrabajo(id_orden_trabajo: number): void {
    this.id_orden_trabajo = id_orden_trabajo;
  }

  public getPedido(): string {
    return this.pedido;
  }

  public setPedido(pedido: string): void {
    this.pedido = pedido;
  }

  public getFechaPedido(): string {
    return this.fecha_pedido;
  }

  public setFechaPedido(fecha_pedido: string): void {
    this.fecha_pedido = fecha_pedido;
  }

  public getEntregaFinal(): string {
    return this.entrega_final;
  }

  public setEntregaFinal(entrega_final: string): void {
    this.entrega_final = entrega_final;
  }

  public getRotulo(): string {
    return this.rotulo;
  }

  public setRotulo(rotulo: string): void {
    this.rotulo = rotulo;
  }

  public getVisto(): boolean {
    return this.visto;
  }

  public setVisto(visto: boolean): void {
    this.visto = visto;
  }

  public getImpreso(): boolean {
    return this.impreso;
  }

  public setImpreso(impreso: boolean): void {
    this.impreso = impreso;
  }

  public getEstadoResultados(): string {
    return this.estado_resultados;
  }

  public setEstadoResultados(estado_resultados: string): void {
    this.estado_resultados = estado_resultados;
  }

  public getEstadoValidacion(): string {
    return this.estado_validacion;
  }

  public setEstadoValidacion(estado_validacion: string): void {
    this.estado_validacion = estado_validacion;
  }

  public getTieneResultadosMarcadosParaAntecedentes(): boolean {
    return this.tiene_resultados_marcados_para_antecedentes;
  }

  public setTieneResultadosMarcadosParaAntecedentes(
    tiene_resultados_marcados_para_antecedentes: boolean
  ): void {
    this.tiene_resultados_marcados_para_antecedentes =
      tiene_resultados_marcados_para_antecedentes;
  }

  public getLetraOrigen(): string {
    return this.letra_origen;
  }

  public setLetraOrigen(letra_origen: string): void {
    this.letra_origen = letra_origen;
  }

  public getNumeroPedido(): string {
    return this.numero_pedido;
  }

  public setNumeroPedido(numero_pedido: string): void {
    this.numero_pedido = numero_pedido;
  }

  public getImpresoFecha(): string {
    return this.impreso_fecha;
  }

  public setImpresoFecha(impreso_fecha: string): void {
    this.impreso_fecha = impreso_fecha;
  }

  public getVistoFecha(): string {
    return this.visto_fecha;
  }

  public setVistoFecha(visto_fecha: string): void {
    this.visto_fecha = visto_fecha;
  }

  public getEsDerivacion(): boolean {
    return this.es_derivacion;
  }

  public setEsDerivacion(es_derivacion: boolean): void {
    this.es_derivacion = es_derivacion;
  }

  // Método para convertir una colección de objetos a instancias de la clase Protocolo
  public static fromCollection(data: any[]): Protocolo[] {
    return data.map(
      (item) =>
        new Protocolo(
          item.id_orden_trabajo,
          item.pedido,
          item.fecha_pedido,
          item.entrega_final,
          item.rotulo,
          item.visto,
          item.impreso,
          item.estado_resultados,
          item.estado_validacion,
          item.tiene_resultados_marcados_para_antecedentes,
          item.letra_origen,
          item.numero_pedido,
          item.impreso_fecha,
          item.visto_fecha,
          item.es_derivacion
        )
    );
  }
}
